import { useCallback, useState } from 'react';
import { BRAND } from './styles/tokens';
import { ScrollProgress, FloatingCTA } from './components/ScrollProgress';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { About, Approach, Testimonials, FAQ, Footer } from './components/Sections';
import { Speaking, SpeakerKit } from './components/Speaking';
import { Training } from './components/Training';
import { Assessments } from './components/Assessment';
import { LeadCapture } from './components/LeadCapture';
import type { LeadPrefill } from './types';

export default function App() {
  const [leadPrefill, setLeadPrefill] = useState<LeadPrefill | null>(null);

  const nav = useCallback((id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, []);

  // Always a fresh object so LeadCapture's effect re-fires on every CTA click.
  const openLead = useCallback((prefill: LeadPrefill = {}) => {
    setLeadPrefill({ ...prefill });
    nav('lead');
  }, [nav]);

  return (
    <>
      <a href="#about" style={{ position: 'absolute', top: -100, left: 0, background: BRAND.warm, color: BRAND.navy, padding: '12px 24px', zIndex: 999, fontSize: 14, fontFamily: "'DM Sans', sans-serif", fontWeight: 700, textDecoration: 'none', borderRadius: '0 0 8px 0' }}
        onFocus={e => e.currentTarget.style.top = '0'}
        onBlur={e => e.currentTarget.style.top = '-100px'}
      >Skip to content</a>
      <ScrollProgress />
      <Nav onNav={nav} />
      <FloatingCTA onNav={nav} />
      <main>
        <Hero onNav={nav} />
        <About />
        <Speaking onLead={openLead} />
        <SpeakerKit />
        <Training onLead={openLead} />
        <Assessments onNav={nav} onLead={openLead} />
        <Approach />
        <Testimonials />
        <FAQ />
        <LeadCapture prefill={leadPrefill} />
      </main>
      <Footer />
    </>
  );
}
